// ✅ New Code
// Filename: src/components/game/AIResultModal.jsx

import classNames from "classnames";
import { useEffect, useState } from "react";
import { AiFillHome } from "react-icons/ai";
import { LuRefreshCcw } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export const AIResultModal = ({ isGameOver, winner, onNewGameClicked, playerRole = "X" }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isGameOver) {
      setIsVisible(false);
      return undefined;
    }

    const id = window.setTimeout(() => setIsVisible(true), 1100);
    return () => window.clearTimeout(id);
  }, [isGameOver]);

  if (!isGameOver || !isVisible) return null;

  const resultMessage = (() => {
    if (winner === "D" || winner === null) return "Draw";
    return winner === playerRole ? "You Won" : "You Lost";
  })();

  const handlePlayAgain = async () => {
    // Step 1: Create the next AI game (HTTP)
    const created = await onNewGameClicked?.();

    // Step 2: Support returning either {id: ...} or raw id
    const newId =
      typeof created === "string" || typeof created === "number" ? created : created?.id;

    if (!newId) {
      console.error("[AIResultModal] onNewGameClicked must return the new game id.", {
        created,
      });
      return;
    }

    // Step 3: Navigate to AI route (no WS provider)
    navigate(`/games/ai/${newId}`);
  };

  return (
    <div className="w-full max-w-[min(92vw,440px)] mx-auto mt-3">
      <div
        className={classNames(
          "w-full rounded-xl px-3 py-3 sm:px-4 text-center",
          "bg-[#060A0D]/95 border border-white/10",
          "shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_18px_38px_rgba(0,0,0,0.42)]"
        )}
      >
        <div
          className={classNames(
            "mb-3 font-mono text-[0.78rem] font-bold uppercase tracking-[0.14em]",
            winner === "D" || winner === null
              ? "text-brand-amber"
              : winner === playerRole
              ? "text-brand-emerald"
              : "text-[#B42323]"
          )}
        >
          {resultMessage}
        </div>

        <div className="flex items-center justify-center gap-2">
          <button
            type="button"
            onClick={handlePlayAgain}
            className={classNames(
              "inline-flex items-center gap-2 rounded-lg px-4 py-2 text-xs font-semibold uppercase tracking-[0.08em]",
              "bg-brand-cyan/10 text-brand-cyan border border-brand-cyan/25",
              "transition duration-200 hover:bg-brand-cyan/15 hover:border-brand-cyan/40"
            )}
          >
            <LuRefreshCcw size={14} />
            Play Again
          </button>

          <button
            type="button"
            onClick={() => navigate("/")}
            className={classNames(
              "inline-flex h-9 w-9 items-center justify-center rounded-lg",
              "bg-white/[0.04] text-text-secondary border border-white/10",
              "transition duration-200 hover:bg-white/[0.07] hover:text-text-primary hover:border-white/20"
            )}
            aria-label="Home"
            title="Home"
          >
            <AiFillHome size={15} />
          </button>
        </div>
      </div>
    </div>
  );
};
